import { useState, useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { debounce } from 'lodash'
import cn from 'clsx'

// Actions
import { actions as browseActions } from 'modules/browse/actions'

// Components
import { IconSearch, IconClose } from '@tracklib/kit'

// Hooks
import { useCurrentQuery } from 'modules/browse/hooks'

// Types
import { QueryObject } from 'types'

import styles from './searchinputfield.css'

type SearchInputFieldProps = {
  filterInputPlaceholder: string
  className?: string
}
const SearchInputField = ({ filterInputPlaceholder, className }: SearchInputFieldProps) => {
  const dispatch = useDispatch()
  const currentQuery = useCurrentQuery()
  const [inputValue, setinputValue] = useState(currentQuery.q || '')
  // NOTE(Kitti): lastQ need to compare q diff if navigating from /tracks to /tracks
  const [lastQ, setLastQ] = useState(currentQuery.q || '')
  const debounceUpdateSearch = useRef(
    debounce((value: string, query: QueryObject) => {
      const { q, ...currentQueryWithoutQ } = query // eslint-disable-line
      dispatch(
        browseActions.updateSearchWithQuery({
          ...currentQueryWithoutQ,
          ...(value ? { q: value } : {}),
        }),
      )
    }, 750),
  )

  const handleChange = ({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => {
    setinputValue(value)
    debounceUpdateSearch.current(value, currentQuery)
  }

  const handleClear = () => {
    setinputValue('')
    debounceUpdateSearch.current('', currentQuery)
  }

  useEffect(() => {
    if (lastQ && !currentQuery.q) {
      setinputValue(currentQuery.q || '')
    }
    // NOTE(Kitti): store previous q to be able to compare
    setLastQ(currentQuery.q || '')
  }, [currentQuery.q]) // eslint-disable-line

  return (
    <div className={cn(styles.wrapper, className)}>
      <div className={styles.searchField} datatesting="browse_textsearch">
        <input type="text" placeholder={filterInputPlaceholder} onChange={handleChange} value={inputValue} aria-label="Search" />
        <IconSearch className={styles.searchIcon} />
      </div>
      {inputValue && <IconClose className={styles.clearIcon} onClick={handleClear} />}
    </div>
  )
}

export default SearchInputField
